import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { FTUE_EVENT_TYPES, FTUE_STEPS_KEYS } from '../../constants';
import { sendFtueEvent } from '../../lib/analytics/ftueLogger';
import { skipTutorialGame } from './utils/skipTutorialGame';
var OnboardingLayer = /*#__PURE__*/function (_React$Component) {
  function OnboardingLayer(props) {
    var _this;
    _classCallCheck(this, OnboardingLayer);
    _this = _callSuper(this, OnboardingLayer, [props]);
    _this.lastLoggedStepRef = React.createRef();
    _this.lastLoggedStepRef.current = 0;
    return _this;
  }
  _inherits(OnboardingLayer, _React$Component);
  return _createClass(OnboardingLayer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var ftueStep = this.props.ftueStep;
      if (ftueStep > FTUE_STEPS_KEYS.INITIAL && ftueStep !== this.lastLoggedStepRef.current) {
        this.lastLoggedStepRef.current = ftueStep;
        ftueStep === FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME && sendFtueEvent(FTUE_EVENT_TYPES.START_GAME_TUTORIAL);
        sendFtueEvent(FTUE_EVENT_TYPES.DISPLAY_GAME_TUTORIAL_STEP, {
          step: ftueStep
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        position = _this$props.position,
        tooltip = _this$props.tooltip,
        ftueStep = _this$props.ftueStep,
        render = _this$props.render,
        clearOnboarding = _this$props.clearOnboarding,
        actionCommands = _this$props.actionCommands;
      if (!position || !position.x || !position.y || !position.width || !position.height) return null;
      return render(_objectSpread(_objectSpread({}, position), {}, {
        tooltip: tooltip,
        ftueStep: ftueStep,
        skipTutorial: function skipTutorial() {
          return skipTutorialGame(ftueStep, clearOnboarding, actionCommands);
        }
      }));
    }
  }]);
}(React.Component);
export { OnboardingLayer as default };